export default "__VITE_ASSET__bYz$c_YF__"